module.exports = __webpack_public_path__ + "media/concept_pipeline-e24aa8f78a2bccbe567864e5266d1413.svg";